import { NAME } from './constants';

export default {
  PAY: `${NAME}/PAY`,
  PAYING: `${NAME}/PAYING`,
  PAY_SUCCESS: `${NAME}/PAY_SUCCESS`,
  PAY_FAILED: `${NAME}/PAY_FAILED`,
  RESET_PAYMENT: `${NAME}/RESET_PAYMENT`,
  SELECT_CARD: `${NAME}/SELECT_CARD`,
  CONFIRM: `${NAME}/CONFIRM`,
};
